module.exports = __webpack_public_path__ + "static/media/Global_Organic_Textile_Standard.8f87740f.svg";